(function() { window.GUID_d8f41b9d_baea_4175_883a_07911a1c8017 = { getGuid: function() { return "d8f41b9d-baea-4175-883a-07911a1c8017"; } }; })();
var CS;
(function (CS) {
    let TimeoutHelper;
    (function (TimeoutHelper) {
        let maxTime = 30000;
        function SetMaxTime(value) {
            maxTime = value;
        }
        TimeoutHelper.SetMaxTime = SetMaxTime;
        let timeout = null;
        function Start(url) {
            if ($('#section-middle').hasClass('refreshing')) {
                Clear();
                timeout = setTimeout(function () {
                    //Le style css est dans masterpage.less
                    let $timeoutContainer = $("<div id='timeout-container'><p>" + JSRess.AjaxTimeOutMessage + "</p></div>");
                    $timeoutContainer.on('click', function () {
                        var url = new URL(window.location.href);
                        var urlStr = window.location.href;
                        if (url.search)
                            urlStr += "&toolongrefresh=true";
                        else
                            urlStr += "?toolongrefresh=true";
                        window.location.href = urlStr;
                    });
                    CS.DOM.$body.append($timeoutContainer);
                }, maxTime);
            }
        }
        TimeoutHelper.Start = Start;
        function Clear() {
            let $exist = $('#timeout-container');
            $exist.remove();
            clearTimeout(timeout);
        }
        TimeoutHelper.Clear = Clear;
        //function UI() {
        //    return '<div id="timeout-container" style="display: none;">' + JSRess.AjaxTimeOutMessage +'</div>';
        //}
    })(TimeoutHelper = CS.TimeoutHelper || (CS.TimeoutHelper = {}));
})(CS || (CS = {}));
//function PrepareTooLongCallData(url: string, extraParams: IAjaxExtraParameters) {
//    FlushTooLongCallData();
//    let $tooLongCallContainer = $('#too-long-call-container');
//    let toolongtimer = setTimeout(function () {
//        if ($('#section-middle').hasClass('refreshing')) {
//            $tooLongCallContainer.show();
//        }
//    }, 15000);
//    $tooLongCallContainer.data('timer', toolongtimer);
//}
//function FlushTooLongCallData() {
//    let $tooLongCallContainer = $('#too-long-call-container');
//    $tooLongCallContainer.hide();
//    if ($tooLongCallContainer.data('timer')) {
//        clearTimeout($tooLongCallContainer.data('timer'));
//    }
//}
//@{
//        <div id="too-long-call-container" style = "display:none;" >
//    <script>
//    function reload() {
//        var url = new URL(window.location.href);
//        if (url.search)
//            url += "&toolongrefresh=true";
//        else
//            url += "?toolongrefresh=true";
//        window.location.href = url;
//    }
//    < /script>
//    < button id = "btn-refresh-toolong-call" class="button button--primary button--big" onclick = "reload();" > @CSRess.TooLongRefreshButtonMessage < /button>
//        < /div>
//    }

//# sourceMappingURL=cs-timeout-helper.js.map
